import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import EMICalculator from "../components/EMICalculator";
import EligibilityChecker from "../components/EligibilityChecker";
import useSEO from "../lib/seo";

export default function Tools() {
  useSEO({
    title: "EMI Calculator & Loan Eligibility Checker",
    description:
      "Free EMI calculator and loan eligibility checker. Estimate monthly EMI, total interest and check how much you may qualify to borrow for home, personal, business, mortgage and professional loans.",
    path: "/tools",
  });
  return (
    <div data-testid="page-tools">
      {/* HERO */}
      <section className="relative border-b border-white/5">
        <div className="absolute inset-0 bg-gradient-to-br from-[#dc2626]/15 via-transparent to-[#1d4ed8]/15" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 lg:py-24">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#dc2626]">
            Financial Tools
          </div>
          <h1 className="mt-5 font-display font-bold text-3xl sm:text-4xl lg:text-6xl tracking-tighter text-white max-w-4xl leading-[0.95]">
            Plan smarter with{" "}
            <span className="text-[#1d4ed8]">EMI</span> &amp;{" "}
            <span className="text-[#dc2626]">Eligibility</span> tools.
          </h1>
          <p className="mt-6 text-lg text-neutral-300 max-w-3xl leading-relaxed">
            Estimate your monthly EMI and check how much you may qualify to
            borrow — all in a few seconds. Real numbers, no hidden fees.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <EMICalculator />
          <EligibilityChecker />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0f0f0f] p-6 sm:p-10 lg:p-16">
            <div className="absolute -top-20 -right-20 h-80 w-80 rounded-full bg-[#dc2626]/20 blur-3xl" />
            <div className="absolute -bottom-20 -left-20 h-80 w-80 rounded-full bg-[#1d4ed8]/20 blur-3xl" />
            <div className="relative flex flex-col lg:flex-row lg:items-end justify-between gap-8">
              <div className="max-w-2xl">
                <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tighter text-white">
                  Ready to apply? Our team will match you to the right lender.
                </h2>
              </div>
              <Link
                to="/request-access"
                data-testid="tools-cta"
                className="inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white px-6 py-4 font-semibold"
              >
                Request Access <ArrowUpRight className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
